<template>
  <div class="container-fluid">
    <div class="row">
      
        <div id="particles-js" class="caja-imagen col-sm-8 px-0 d-none d-sm-block">
          <div class="text-login">
            <div class="texto">
              <h4>Bienvenido al Sistema Web</h4>
              <h1>Proyección Social</h1>
              <h1>"LLAQTA"</h1>
              <h4>UPLA <span class="fas fa-users"></span></h4>

            </div>
          </div>
          <vue-particles 
            color="#ffffff"
            :particleOpacity="0.7"
            :particlesNumber="120"
            shapeType="circle"
            :particleSize="4"
            linesColor="#ffffff"
            :linesWidth="1"
            :lineLinked="true"
            :lineOpacity="0.4"
            :linesDistance="150"
            :moveSpeed="4"
            :hoverEffect="true"
            hoverMode="repulse"
            :clickEffect="true"
            clickMode="push"
          >
        </vue-particles>
        </div>

      <div class="col-sm-4 shadow">
        <div class="hold-transition login-page">
          <div class="card card-outline mr-5 ml-5">

            <div class=" text-center" id="logo">
              <img src="@/views/assets/img/template/logoupla6.gif" id="icon" alt="User Icon" />
            </div>
            <div class="card-body">
              <p class="login-box-msg">Por favor ingrese a su cuenta</p>

              <form v-on:submit.prevent="login">
                <div class="input-group mb-3">
                  <p>Código</p>
                  <div class="input-group">
                    <input type="text" id="login" class="form-control" placeholder="Digite su código" v-model="persEmail" required>
                  </div>
                </div>
                <div class="input-group mb-3">
                  <p>Contraseña</p>
                  <div class="input-group">
                    <input type="password" id="password" class="form-control" placeholder="Digite su contraseña" v-model="persPassword" required>
                    <span class="input-group-append">
                      <button type="button" class="btn bg-black btn-flat" @click="togglePasswordVisibility()"><span class="fas fa-eye"></span></button>
                    </span>
                  </div>
                </div>
          
   
                <div class="row" >
                  <div class="col-12">
                    <div class="icheck-primary">
                      <input type="checkbox" id="remember">
                      <label for="remember">
                         Recordarme
                      </label>
                    </div>
                  </div>
                  
                  <!-- /.col -->
                  <div class="col-12">
                    <button type="submit" class="btn btn-primary btn-block" style="background-color: #007CBD; color: #fff;">Ingresar</button>
                  </div>
                  <div class="col-12 alert alert-danger mt-3 mb-1" role="alert" v-if="error">
                    {{ error_msg }}
                  </div>
                  <!-- /.col -->
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import VueJwtDecode from 'vue-jwt-decode';
// import { mapActions } from 'vuex';
export default {
  name: 'login',
  components: {

  },
  data: function () {
    return {
      persEmail: "",
      persPassword: "",
      error: false,
      error_msg: null,
      user : null,
    }
  },
  // computed:{
  //   loggedIn(){
  //     return this.$store.state.auth.status.loggedIn;
  //   }
  // },
  created() {
    if (this.loggedIn) {
      this.$router.push('/inicio');
    }
  },
  methods: {
    togglePasswordVisibility() {
      const passwordInput = document.getElementById('password');
      passwordInput.type = passwordInput.type === 'password' ? 'text' : 'password';
    },

    async login() {
  const data = {
    codigo: this.persEmail,
    contraseña: this.persPassword,
  };

  try {
    const http = this.axios || axios;

    const response = await http.post("https://services.upla.edu.pe/Login", data);

    // ✅ tu API retorna todo en raíz:
    const res = response?.data || {};
    const token = res.token;

    if (!token) {
      this.error_msg = "Respuesta inválida del servidor (no llegó token).";
      this.error = true;
      return;
    }

    // ✅ guarda token y datos (en raíz)
    sessionStorage.setItem("token", token);
    sessionStorage.setItem("codigo", res.docNumId || "");
    sessionStorage.setItem("ApellidoP", res.persPaterno || "");
    sessionStorage.setItem("ApellidoM", res.persMaterno || "");
    sessionStorage.setItem("Nombres", res.persNombre || "");

    // ✅ setea header para futuras requests (misma instancia)
    http.defaults.headers.common.Authorization = `Bearer ${token}`;

    // ✅ store
    try {
      await this.$store.dispatch("auth/login");
    } catch (e) {
      console.log("store auth/login error:", e);
    }

    // ✅ decode seguro
    let decoded;
    try {
      decoded = VueJwtDecode.decode(token);
    } catch (e) {
      console.log("JWT decode error:", e);
      sessionStorage.clear();
      localStorage.clear();
      this.error_msg = "Token inválido o no se pudo decodificar.";
      this.error = true;
      return;
    }

    const claim = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
    let roles = decoded?.[claim];
    roles = Array.isArray(roles) ? roles : roles ? [roles] : [];

    console.log("roles:", roles);

    const ok =
      roles.includes("ProyeccionAdministacion") ||
      roles.includes("ProyeccionOperaciones");

    if (!ok) {
      sessionStorage.clear();
      localStorage.clear();
      this.error_msg = "No tiene los permisos para poder ingresar";
      this.error = true;
      return;
    }

    // ✅ navega
    this.$router.push("/inicio").catch((e) => console.log("router push:", e));
  } catch (error) {
    console.log("AXIOS ERROR:", error);

    const mensajeError =
      error?.response?.data ||
      error?.response?.statusText ||
      error?.message ||
      "Error de conexión (sin respuesta del servidor)";

    this.error_msg = mensajeError;
    this.error = true;
  }
}

  }

}

</script>

<style scoped>
  .login-page {
    background-color: white;
  
  }

  .caja-imagen {
    --opacidad-negro: 0.2; 
    background-image: linear-gradient(rgba(0, 0, 0, var(--opacidad-negro)), rgba(0, 0, 0, var(--opacidad-negro))),url('@/assets/por.jpg');
    ;background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;
    height: 100vh;
    float: left;
    display: flex;
    justify-content: center;
    align-items: center;

  }

  #logo{
    display: block;
    margin: auto;
    width: 50%;
  }
  .caja-texto {
    text-align: center;
    display: flex;
    align-items: center;
  }
  .texto {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: 'Montserrat', sans-serif !important;
    text-align: center;
  }
  .text-login h1 {
    color: #fff;
    font-size: 2.9rem;
    font-weight: bold;
  }
  .text-login h4 {
    color: #fff;
    font-size: 1.9rem;
  }
  

  
  
  /* OTHERS */
  
  *:focus {
    outline: none;
  }
  
  #icon {
    width: 60%;
  }

</style>